// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SirmetJakamoApi {
	export async function fetchJakamoOrders(): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/sirmet/jakamo/fetchJakamoOrders",
			method: "POST",
			data: {},
		});
		return response as void;
	}
}
